
import InnerLoading from '~/components/Shared/Loading/InnerLoading.vue'
import { mapGetters } from 'vuex'

const PAYMENT_INTERVALS = [
  { value: 0, key: 'daily' },
  { value: 1, key: 'weekly' },
  { value: 2, key: 'monthly' },
  { value: 3, key: 'yearly' },
]

const CURRENCY_MAP = {
  0: 'TRY',
  1: 'USD',
  2: 'EUR',
  3: 'GBP',
}

export default {
  name: 'ProductSubscription',
  components: {
    InnerLoading,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    productInfo: {
      type: Object,
      default: () => {},
    },
    subscriptions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      getUserSubscriptions: 'user/getUserSubscriptions',
    }),
    shouldRender() {
      return (
        this.isLoading || this.subscriptions.length > 0 || this.errorMessage
      )
    },
    userSubscriptionPackageIds() {
      // Kullanıcının sahip olduğu abonelik paket ID'lerini al
      const userSubs = Array.isArray(this.getUserSubscriptions)
        ? this.getUserSubscriptions
        : this.getUserSubscriptions?.subscriptions || []
      return userSubs
        .map((sub) => sub.subscriptionPackageId)
        .filter((id) => id != null && id !== undefined)
    },
  },
  methods: {
    isPackageOwned(packageId) {
      // Paket ID'si kullanıcının aboneliklerinde var mı kontrol et
      return this.userSubscriptionPackageIds.includes(Number(packageId))
    },
    formatPrice(amount, currencyCode) {
      const currency =
        typeof currencyCode === 'string'
          ? currencyCode
          : CURRENCY_MAP[currencyCode] || 'TRY'

      try {
        return new Intl.NumberFormat(this.$i18n.locale || 'tr-TR', {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        }).format(Number(amount) || 0)
      } catch (error) {
        return `${Number(amount) || 0} ${currency}`
      }
    },
    intervalLabel(value) {
      const interval = PAYMENT_INTERVALS.find(
        (interval) => interval.value === Number(value)
      )
      if (!interval) return ''

      return this.$custom$t(`pricing.intervalLabels.${interval.key}.short`)
    },
  },
}
